import { render, staticRenderFns } from "./Gender.vue?vue&type=template&id=021c1a72&scoped=true&"
import script from "./Gender.vue?vue&type=script&lang=js&"
export * from "./Gender.vue?vue&type=script&lang=js&"
import style0 from "./Gender.vue?vue&type=style&index=0&id=021c1a72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021c1a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021c1a72')) {
      api.createRecord('021c1a72', component.options)
    } else {
      api.reload('021c1a72', component.options)
    }
    module.hot.accept("./Gender.vue?vue&type=template&id=021c1a72&scoped=true&", function () {
      api.rerender('021c1a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/Input/Gender.vue"
export default component.exports